// Translation dictionary for Spanish (default) and English
export const translations = {
    es: {
        nav: {
            home: "Inicio",
            menu: "Menú",
            chefs: "Las Chefs",
            about: "Nosotras",
            contact: "Contacto",
            order: "Ordenar",
            admin: "Admin",
            cart: "Carrito",
        },
        hero: {
            tag: "Cocina Dominicana Auténtica · Montego Bay",
            title: "Sabor de la isla,",
            titleAccent: "hecho en casa",
            subtitle:
                "Pasteles en hoja, chicharrón, chivo guisado y mucho más — tradición dominicana servida con amor a la comunidad y a los amantes del buen comer en Jamaica.",
            cta: "Ordenar Ahora",
            cta2: "Ver el Menú",
            badge1: "Recetas Familiares",
            badge2: "Ingredientes Frescos",
            badge3: "Hecho a Mano",
        },
        menu: {
            tag: "Nuestro Menú",
            title: "Especialidades Dominicanas",
            subtitle:
                "Cada plato cuenta una historia. Desde el campo hasta tu mesa, sabores que abrazan el alma.",
            add: "Agregar",
            added: "Agregado",
            featured: "Favorito",
            from: "Desde",
            empty: "Cargando menú...",
        },
        chefs: {
            tag: "Las Manos Detrás",
            title: "Conoce a Chef Milly",
            subtitle:
                "Una cocinera dedicada, generaciones de sabor dominicano. Cada plato es una carta de amor a nuestra tierra.",
            uploadMilly: "Subir foto de Milly",
            enhance: "Mejorar con IA",
            enhancing: "Mejorando...",
            captureNew: "Cambiar foto",
            ai: "IA",
            chefMillyBio:
                "Reina de las masas, los guisos y los postres. Sus pasteles en hoja son legendarios en toda la diáspora dominicana — recetas heredadas de su abuela en Santo Domingo, cocinadas a fuego lento y con paciencia caribeña.",
        },
        about: {
            tag: "Nuestra Historia",
            title: "De la cocina dominicana al corazón de Jamaica",
            body1:
                "Delicias Dominicanas nació de la nostalgia por los sabores de casa y del deseo de compartirlos con nuestra comunidad en Montego Bay. Lo que empezó como una cena entre amigas se ha convertido en una experiencia culinaria que une dos islas y muchas familias.",
            body2:
                "Cocinamos como cocinaban nuestras abuelas: con tiempo, con paciencia y con el sazón que solo el cariño puede dar. Ya sea un antojito, una fiesta de cumpleaños o cualquier ocasión especial — estamos listas para cocinar para ti.",
            stat1: "Recetas tradicionales",
            stat2: "Familias felices",
            stat3: "Años de sabor",
        },
        order: {
            tag: "Hagamos tu Pedido",
            title: "Ordenar es muy fácil",
            step1: "Elige tus platos del menú",
            step2: "Completa tus datos",
            step3: "Paga en efectivo o por transferencia",
            name: "Nombre completo",
            phone: "Teléfono",
            email: "Email (opcional)",
            address: "Dirección de entrega",
            notes: "Notas especiales (alergias, instrucciones)",
            payment: "Método de pago",
            payCash: "WhatsApp + Pago al recoger",
            payCard: "Tarjeta de crédito / débito",
            placeOrder: "Confirmar Pedido",
            success: "¡Pedido enviado! Te contactamos por WhatsApp.",
            sending: "Enviando...",
            emptyCart: "Tu carrito está vacío. Agrega platos del menú.",
            sendWhatsapp: "Enviar pedido por WhatsApp",
            checkoutStripe: "Pagar con tarjeta",
            requiredFields: "Por favor completa tu nombre y teléfono.",
            deliveryMethod: "Método de entrega",
            pickup: "Recoger en tienda",
            pickupSub: "Gratis · Montego Bay",
            delivery: "Delivery a domicilio",
            deliveryFee: "Costo de entrega",
            deliveryFree: "Gratis sobre $100",
            addressRequired: "Por favor agrega tu dirección de entrega.",
            subtotal: "Subtotal",
        },
        cart: {
            title: "Tu Carrito",
            subtotal: "Subtotal",
            total: "Total",
            checkout: "Proceder a Pedido",
            empty: "Aún no hay platos. ¡Elige tus favoritos!",
            remove: "Quitar",
            qty: "Cant.",
            continue: "Seguir comprando",
        },
        contact: {
            tag: "Contáctanos",
            title: "Estamos en Montego Bay",
            subtitle: "Pide por WhatsApp o llámanos. Cocinamos por encargo todos los días.",
            location: "Montego Bay, Jamaica",
            hours: "Mar – Dom · 10:00 AM – 9:00 PM",
            whatsappCta: "Chatear por WhatsApp",
        },
        footer: {
            tagline: "Cocina dominicana hecha con amor en Jamaica.",
            rights: "Todos los derechos reservados.",
            dominicanProud: "Hecho con corazón dominicano",
        },
        share: {
            tag: "Comparte el sabor",
            title: "Invita a tus amigos a probar",
            subtitle: "Escanea el código QR o comparte el enlace por WhatsApp para que tus seres queridos descubran nuestra cocina dominicana.",
            scanHint: "Apunta tu cámara al código",
            whatsappBtn: "Compartir por WhatsApp",
            copyBtn: "Copiar enlace",
            copied: "¡Enlace copiado!",
            whatsappMessage: "¡Mira esta cocina dominicana que estoy probando! 🇩🇴 Pide directo por WhatsApp:",
        },
        catering: {
            tag: "Catering & Eventos",
            title: "¿Tienes un evento especial?",
            subtitle: "Cocinamos para tu cumpleaños, bautizo, boda o cualquier celebración. Cuéntanos los detalles y te enviamos una cotización personalizada.",
            name: "Nombre completo",
            phone: "Teléfono",
            email: "Email",
            date: "Fecha del evento",
            type: "Tipo de evento",
            guests: "Número de invitados",
            budget: "Presupuesto estimado (USD)",
            menu: "Menú preferido (opcional)",
            notes: "Detalles adicionales",
            submit: "Solicitar Cotización",
            success: "¡Solicitud recibida! Te contactamos pronto.",
            types: {
                cumpleanos: "Cumpleaños",
                boda: "Boda",
                bautizo: "Bautizo",
                quinceanera: "Quinceañera",
                corporativo: "Evento Corporativo",
                otro: "Otro",
            },
        },
        loyalty: {
            title: "Tarjeta de Fidelidad",
            progress: "Pedidos hasta tu próximo plato gratis",
            earned: "¡Felicidades! Tienes",
            free: "platos gratis acumulados",
            keepGoing: "Solo",
            more: "pedidos más para tu próximo plato gratis",
            firstOrder: "Cada 10 pedidos = 1 plato gratis. ¡Empieza hoy!",
        },
        tracking: {
            title: "Seguimiento de Pedido",
            placeholder: "Pega el ID de tu pedido aquí",
            track: "Rastrear",
            notFound: "Pedido no encontrado",
            steps: {
                new: "Recibido",
                pending_confirmation: "Pendiente de confirmación",
                confirmed: "Confirmado",
                preparing: "Preparando",
                ready: "Listo para recoger",
                delivered: "Entregado",
                cancelled: "Cancelado",
            },
        },
        admin: {
            loginTitle: "Acceso de Administración",
            username: "Usuario",
            password: "Contraseña",
            or: "o",
            pin: "PIN de 4 dígitos",
            login: "Entrar",
            invalid: "Credenciales inválidas",
            forgotPassword: "¿Olvidaste tu contraseña?",
            resetTitle: "Restablecer contraseña",
            resetSubtitle: "Usa tu código de recuperación o el email del administrador.",
            resetMethodCode: "Código de recuperación",
            resetMethodEmail: "Email del administrador",
            resetCodePlaceholder: "ABCD-EFGH-JKMN-PQRS",
            resetEmailPlaceholder: "admin@tu-dominio.com",
            resetSendCode: "Verificar código",
            resetSendEmail: "Enviar enlace por email",
            resetEmailSent: "Si el email coincide, te enviamos un enlace en {minutes} minutos.",
            resetCodeAccepted: "Código verificado. Ingresa tu nueva contraseña.",
            resetNewPassword: "Nueva contraseña (mínimo 10 caracteres)",
            resetNewPin: "Nuevo PIN (4-6 dígitos, opcional)",
            resetSubmit: "Guardar nueva contraseña",
            resetSuccess: "Contraseña actualizada. Inicia sesión con tu nueva clave.",
            resetTokenExpired: "El enlace expiró. Pídelo de nuevo.",
            resetBackToLogin: "Volver a iniciar sesión",
            ordersTitle: "Pedidos",
            menuTitle: "Menú",
            logout: "Cerrar sesión",
            new: "Nuevo",
            pending_confirmation: "Pendiente confirmación",
            confirmed: "Confirmado",
            preparing: "Preparando",
            ready: "Listo",
            delivered: "Entregado",
            cancelled: "Cancelado",
            paid: "Pagado",
            pending: "Pendiente",
            cashOnPickup: "Efectivo",
            noOrders: "Aún no hay pedidos.",
            tabs: {
                orders: "Pedidos",
                calendar: "Calendario",
                catering: "Catering",
                menu: "Menú",
                subscribers: "Lista de avisos",
                testimonials: "Testimonios",
                profitability: "Rentabilidad",
                tenants: "Inquilinos",
                settings: "Configuración",
            },
            active: "Activos",
            archived: "Archivados",
            archive: "Archivar",
            unarchive: "Restaurar",
            delete: "Eliminar",
            confirm: "Confirmar",
            markPaid: "Marcar pagado",
            save: "Guardar",
            saving: "Guardando…",
            cancel: "Cancelar",
            add: "Añadir",
            edit: "Editar",
            saveChanges: "Guardar cambios",
            settingsTitle: "Configuración",
            settingsSubtitle: "Personaliza por completo el sitio: marca, hero, contacto, banner, chef y métodos de pago. Los cambios se aplican al instante.",
            sectionBrand: "Identidad de marca",
            sectionBrandSub: "Nombre, iniciales, colores. Define la personalidad visual de todo el sitio.",
            sectionCurrency: "Moneda",
            sectionCurrencySub: "Símbolo y posición del símbolo. Afecta todos los precios del sitio.",
            sectionCountry: "País y decoraciones culturales",
            sectionCountrySub: "Elige la bandera del país. Toggle para mostrar u ocultar las palmas, banderines y rayas tricolor.",
            sectionHero: "Hero principal",
            sectionHeroSub: "Lo primero que ve el cliente. Edita en español e inglés.",
            sectionHeroBadges: "Insignias del Hero",
            sectionHeroBadgesSub: "Los 3 pequeños badges debajo del CTA principal.",
            sectionAbout: "Sección 'Sobre nosotros'",
            sectionAboutSub: "Título, historia y estadísticas. Deja en blanco para usar el copy por defecto.",
            sectionChef: "Chef / Cocinero",
            sectionChefSub: "Nombre, biografía y foto del chef que aparece en la sección 'Conoce al chef'.",
            sectionContact: "Contacto",
            sectionContactSub: "Ciudad, dirección y horarios mostrados en la sección Contacto.",
            sectionAnnouncement: "Banner de aviso",
            sectionAnnouncementSub: "Mensaje destacado en la parte superior del sitio. Deja en blanco para usar el mensaje por defecto.",
            sectionWhatsApp: "Número de WhatsApp del negocio",
            sectionWhatsAppSub: "Recibe los pedidos de los clientes y desde aquí también se confirman.",
            sectionPayments: "Métodos de pago",
            sectionPaymentsSub: "Activa o desactiva cada método. Los desactivados no aparecen al hacer pedido.",
            dangerZone: "Zona peligrosa",
            dangerZoneSub: "Acciones destructivas e irreversibles.",
            wipeOrders: "Eliminar TODOS los pedidos + catering",
            wipeOrdersConfirm: "⚠️ Vas a eliminar PERMANENTEMENTE todos los pedidos Y solicitudes de catering (activos y archivados).\n\nEscribe ELIMINAR para confirmar:",
            wipeOrdersFinal: "Última confirmación: ¿borrar TODOS los pedidos y catering? No se puede deshacer.",
            wipeOrdersTypeWrong: "Cancelado — texto no coincide",
            wipeOrdersDone: "{orders} pedidos + {catering} solicitudes de catering eliminadas",
            visible: "Visible",
            hidden: "Oculto",
            enabled: "Activo",
            disabled: "Inactivo",
        },
        common: {
            success: "Éxito",
            error: "Error",
            loading: "Cargando...",
            close: "Cerrar",
        },
    },
    en: {
        nav: {
            home: "Home",
            menu: "Menu",
            chefs: "The Chefs",
            about: "About",
            contact: "Contact",
            order: "Order",
            admin: "Admin",
            cart: "Cart",
        },
        hero: {
            tag: "Authentic Dominican Kitchen · Montego Bay",
            title: "Island flavor,",
            titleAccent: "made at home",
            subtitle:
                "Pasteles en hoja, chicharrón, stewed goat and so much more — Dominican tradition lovingly served to the community and to food lovers across Jamaica.",
            cta: "Order Now",
            cta2: "See the Menu",
            badge1: "Family Recipes",
            badge2: "Fresh Ingredients",
            badge3: "Handmade",
        },
        menu: {
            tag: "Our Menu",
            title: "Dominican Specialties",
            subtitle:
                "Every dish tells a story. From the countryside to your table, flavors that warm the soul.",
            add: "Add",
            added: "Added",
            featured: "Favorite",
            from: "From",
            empty: "Loading menu...",
        },
        chefs: {
            tag: "The Hands Behind",
            title: "Meet Chef Milly",
            subtitle:
                "A dedicated home cook, generations of Dominican flavor. Every plate is a love letter to our homeland.",
            uploadMilly: "Upload Milly's photo",
            enhance: "Enhance with AI",
            enhancing: "Enhancing...",
            captureNew: "Change photo",
            ai: "AI",
            chefMillyBio:
                "Queen of the doughs, the stews and the desserts. Her pasteles en hoja are legendary across the Dominican diaspora — recipes inherited from her grandmother in Santo Domingo, slow-cooked with Caribbean patience.",
        },
        about: {
            tag: "Our Story",
            title: "From the Dominican kitchen to the heart of Jamaica",
            body1:
                "Delicias Dominicanas was born from nostalgia for the flavors of home and the wish to share them with our community in Montego Bay. What started as a dinner among friends has become a culinary experience that connects two islands and many families.",
            body2:
                "We cook the way our grandmothers cooked: with time, patience and the seasoning that only love can give. Whether it's a craving, a birthday party or any special occasion — we're ready to cook for you.",
            stat1: "Traditional recipes",
            stat2: "Happy families",
            stat3: "Years of flavor",
        },
        order: {
            tag: "Place Your Order",
            title: "Ordering is easy",
            step1: "Pick your dishes",
            step2: "Fill in your details",
            step3: "Pay in cash or by transfer",
            name: "Full name",
            phone: "Phone",
            email: "Email (optional)",
            address: "Delivery address",
            notes: "Special notes (allergies, instructions)",
            payment: "Payment method",
            payCash: "WhatsApp + Cash on pickup",
            payCard: "Credit / debit card",
            placeOrder: "Confirm Order",
            success: "Order sent! We'll contact you via WhatsApp.",
            sending: "Sending...",
            emptyCart: "Your cart is empty. Pick dishes from the menu.",
            sendWhatsapp: "Send order on WhatsApp",
            checkoutStripe: "Pay by card",
            requiredFields: "Please fill in your name and phone.",
            deliveryMethod: "Delivery method",
            pickup: "Pickup at the kitchen",
            pickupSub: "Free · Montego Bay",
            delivery: "Home delivery",
            deliveryFee: "Delivery fee",
            deliveryFree: "Free over $100",
            addressRequired: "Please add your delivery address.",
            subtotal: "Subtotal",
        },
        cart: {
            title: "Your Cart",
            subtotal: "Subtotal",
            total: "Total",
            checkout: "Proceed to Order",
            empty: "Nothing here yet. Pick your favorites!",
            remove: "Remove",
            qty: "Qty",
            continue: "Keep browsing",
        },
        contact: {
            tag: "Contact Us",
            title: "We're in Montego Bay",
            subtitle: "Order via WhatsApp or call us. We cook by order every day.",
            location: "Montego Bay, Jamaica",
            hours: "Tue – Sun · 10:00 AM – 9:00 PM",
            whatsappCta: "Chat on WhatsApp",
        },
        footer: {
            tagline: "Dominican kitchen, made with love in Jamaica.",
            rights: "All rights reserved.",
            dominicanProud: "Made with a Dominican heart",
        },
        share: {
            tag: "Share the flavor",
            title: "Invite your friends to taste",
            subtitle: "Scan the QR code or share the link on WhatsApp so your loved ones can discover our Dominican kitchen.",
            scanHint: "Point your camera at the code",
            whatsappBtn: "Share on WhatsApp",
            copyBtn: "Copy link",
            copied: "Link copied!",
            whatsappMessage: "Check out this Dominican kitchen I'm loving! 🇩🇴 Order directly on WhatsApp:",
        },
        catering: {
            tag: "Catering & Events",
            title: "Got a special event?",
            subtitle: "We cook for your birthday, baptism, wedding, or any celebration. Tell us the details and we'll send you a personalized quote.",
            name: "Full name",
            phone: "Phone",
            email: "Email",
            date: "Event date",
            type: "Event type",
            guests: "Number of guests",
            budget: "Estimated budget (USD)",
            menu: "Preferred menu (optional)",
            notes: "Extra details",
            submit: "Request a Quote",
            success: "Request received! We'll contact you soon.",
            types: {
                cumpleanos: "Birthday",
                boda: "Wedding",
                bautizo: "Baptism",
                quinceanera: "Quinceañera",
                corporativo: "Corporate event",
                otro: "Other",
            },
        },
        loyalty: {
            title: "Loyalty Card",
            progress: "Orders until your next free plate",
            earned: "Congrats! You have",
            free: "free plates earned",
            keepGoing: "Just",
            more: "more orders for your next free plate",
            firstOrder: "Every 10 orders = 1 free plate. Start today!",
        },
        tracking: {
            title: "Order Tracking",
            placeholder: "Paste your order ID here",
            track: "Track",
            notFound: "Order not found",
            steps: {
                new: "Received",
                pending_confirmation: "Pending confirmation",
                confirmed: "Confirmed",
                preparing: "Preparing",
                ready: "Ready for pickup",
                delivered: "Delivered",
                cancelled: "Cancelled",
            },
        },
        admin: {
            loginTitle: "Admin Sign In",
            username: "Username",
            password: "Password",
            or: "or",
            pin: "4-digit PIN",
            login: "Sign in",
            invalid: "Invalid credentials",
            forgotPassword: "Forgot your password?",
            resetTitle: "Reset password",
            resetSubtitle: "Use your recovery code or the admin email on file.",
            resetMethodCode: "Recovery code",
            resetMethodEmail: "Admin email",
            resetCodePlaceholder: "ABCD-EFGH-JKMN-PQRS",
            resetEmailPlaceholder: "admin@your-domain.com",
            resetSendCode: "Verify code",
            resetSendEmail: "Send email link",
            resetEmailSent: "If the email matches, a reset link is on its way ({minutes} min).",
            resetCodeAccepted: "Code verified. Enter your new password.",
            resetNewPassword: "New password (min 10 characters)",
            resetNewPin: "New PIN (4-6 digits, optional)",
            resetSubmit: "Save new password",
            resetSuccess: "Password updated. Log in with your new credentials.",
            resetTokenExpired: "Link expired. Please request a new one.",
            resetBackToLogin: "Back to login",
            ordersTitle: "Orders",
            menuTitle: "Menu",
            logout: "Sign out",
            new: "New",
            pending_confirmation: "Pending confirmation",
            confirmed: "Confirmed",
            preparing: "Preparing",
            ready: "Ready",
            delivered: "Delivered",
            cancelled: "Cancelled",
            paid: "Paid",
            pending: "Pending",
            cashOnPickup: "Cash",
            noOrders: "No orders yet.",
            tabs: {
                orders: "Orders",
                calendar: "Calendar",
                catering: "Catering",
                menu: "Menu",
                subscribers: "Notify list",
                testimonials: "Testimonials",
                profitability: "Profitability",
                tenants: "Tenants",
                settings: "Settings",
            },
            active: "Active",
            archived: "Archived",
            archive: "Archive",
            unarchive: "Restore",
            delete: "Delete",
            confirm: "Confirm",
            markPaid: "Mark paid",
            save: "Save",
            saving: "Saving…",
            cancel: "Cancel",
            add: "Add",
            edit: "Edit",
            saveChanges: "Save changes",
            settingsTitle: "Settings",
            settingsSubtitle: "Customize the entire site: brand, hero, contact, banner, chef and payment methods. Changes apply instantly.",
            sectionBrand: "Brand identity",
            sectionBrandSub: "Name, initials, colors. Defines the visual personality of the whole site.",
            sectionCurrency: "Currency",
            sectionCurrencySub: "Symbol and its position. Affects all prices on the site.",
            sectionCountry: "Country & cultural decorations",
            sectionCountrySub: "Pick the country's flag. Toggle to show or hide palms, flags and tricolor stripes.",
            sectionHero: "Main hero",
            sectionHeroSub: "What the customer sees first. Edit in Spanish and English.",
            sectionHeroBadges: "Hero badges",
            sectionHeroBadgesSub: "The 3 small badges under the main CTA.",
            sectionAbout: "About section",
            sectionAboutSub: "Title, story and stats. Leave blank to use the default copy.",
            sectionChef: "Chef",
            sectionChefSub: "Name, bio and photo of the chef shown in the 'Meet the chef' section.",
            sectionContact: "Contact",
            sectionContactSub: "City, address and hours shown in the Contact section.",
            sectionAnnouncement: "Announcement banner",
            sectionAnnouncementSub: "Highlighted message at the top of the site. Leave blank for the default message.",
            sectionWhatsApp: "Business WhatsApp number",
            sectionWhatsAppSub: "Receives customer orders and confirms them from here too.",
            sectionPayments: "Payment methods",
            sectionPaymentsSub: "Enable or disable each method. Disabled ones don't appear at checkout.",
            dangerZone: "Danger zone",
            dangerZoneSub: "Destructive, irreversible actions.",
            wipeOrders: "Delete ALL orders + catering",
            wipeOrdersConfirm: "⚠️ You will PERMANENTLY delete every order AND catering request (active and archived).\n\nType DELETE to confirm:",
            wipeOrdersFinal: "Last confirmation: delete ALL orders and catering? This cannot be undone.",
            wipeOrdersTypeWrong: "Cancelled — text doesn't match",
            wipeOrdersDone: "{orders} orders + {catering} catering requests deleted",
            visible: "Visible",
            hidden: "Hidden",
            enabled: "Active",
            disabled: "Inactive",
        },
        common: {
            success: "Success",
            error: "Error",
            loading: "Loading...",
            close: "Close",
        },
    },
};

export const detectLanguage = () => {
    const stored = typeof window !== "undefined" && localStorage.getItem("lang");
    if (stored === "es" || stored === "en") return stored;
    if (typeof navigator !== "undefined") {
        const lang = (navigator.language || "es").toLowerCase();
        if (lang.startsWith("en")) return "en";
    }
    return "es";
};
